import { render, staticRenderFns } from "./NewFloorModal.vue?vue&type=template&id=227b9eaf&"
import script from "./NewFloorModal.vue?vue&type=script&lang=js&"
export * from "./NewFloorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports